.<template>
  <div class="col-sm-12">
    <div v-if="!loading">
      <div class="row">
        <div class="col-sm-12">
          <h1>
            <button class="btn btn-sm btn-dark back" type="button" v-on:click="showArea">
              <i class="fa fa-caret-left"></i>
              Tillbaka
            </button>
            <span>Detaljer</span>
            <button class="btn btn-sm btn-dark filter" type="button" v-on:click="showDescription">
              Beskrivning
            </button>
          </h1>
        </div>
      </div>
      <div class="row content">
        <div class="col-sm-12">
          <a class="map" :href="'http://maps.google.com/?q=' + spot.latitude + ',' + spot.longitude">
            <img :src="map" alt="Karta" v-if="spot.id" />
          </a>
          <span class="title">{{ spot.title }}</span>
        </div>
      </div>
      <div class="row content">
        <ul class="stats">
          <li class="stats-item">
            <span class="stats-item-caption">Planterat</span>
            <span class="stats-item-season" :class="`season-${season.id}`"></span>
            <span class="stats-item-value">{{ season.title }}</span>
          </li>
          <li class="stats-item" v-if="spot.plant_type">
            <span class="stats-item-caption">Planteringstyp</span>
            <span class="stats-item-value">{{ spot.plant_type.title }}</span>
          </li>
          <li class="stats-item" v-if="spot.latest_visit">
            <span class="stats-item-caption">Senast besökt</span>
            <span class="stats-item-value">{{ spot.latest_visit.time_of_visit }}</span>
          </li>
          <li class="stats-item">
            <span class="stats-item-caption">Senast vattnad</span>
            <span class="stats-item-value" :class="{ overdue: overdue }">{{
              spot.latest_watered ? spot.latest_watered.time_of_visit : 'Aldrig'
            }}</span>
          </li>
          <li class="stats-item" v-if="spot.latest_visit">
            <span class="stats-item-caption">Senaste tillsyn</span>
            <span class="stats-item-value">{{ latestActions }}</span>
          </li>
        </ul>
      </div>
      <div class="row content" v-if="hasNotes">
        <ul class="notes">
          <li class="notes-item" v-for="note in spot.notes" :key="note.id">
            <span class="notes-item-value">
              <span class="notes-item-date">
                {{ formatDate(note.created_at) }}
              </span>
              {{ note.value }}
            </span>
            <span class="pull-right notes-item-actions">
              <i class="fa fa-pencil" v-on:click="showNoteDialog(note)"></i>
              <i class="fa fa-times" v-on:click="showRemoveNoteDialog(note)"></i>
            </span>
          </li>
        </ul>
      </div>
      <div class="row content">
        <div class="col-sm-12 actions">
          <button class="btn btn-light form-control" v-on:click="showPreviousSpot" v-if="!isFirstSpot">
            Föregående
          </button>
          <button class="btn btn-light form-control" v-on:click="showActionDialog">
            Tillsyn
          </button>
          <button class="btn btn-light form-control" v-on:click="showSeasonDialog">
            Byt säsong
          </button>
          <button class="btn btn-light form-control" v-on:click="showNoteDialog()">
            Lägg till anteckning
          </button>
          <button class="btn btn-light form-control" v-on:click="showNextSpot" v-if="!isLastSpot">
            Nästa
          </button>
        </div>
      </div>
    </div>

    <div class="overlay" v-if="modal.visible" v-on:click="closeModal">
      <div class="dialog" v-if="modal.type === 'description'" v-on:click="preventModalClose">
        <div class="dialog-header">
          <h2>Beskrivning</h2>
        </div>
        <div class="dialog-body">
          <p>
            {{ this.spot.description }}
          </p>
          <button class="btn btn-light form-control btn-close" type="button" v-on:click="closeModal">
            Stäng
          </button>
        </div>
      </div>

      <div class="dialog" v-if="modal.type === 'action'" v-on:click="preventModalClose">
        <div class="dialog-header">
          <h2>Tillsyn</h2>
        </div>
        <div class="dialog-body">
          <form>
            <div class="form-group vertical">
              <label>Typ av tillsyn</label>
              <!-- <select class="form-control" v-model="modal.value">
                <option
                  v-for="(actionType, index) in actionTypes"
                  :value="actionType"
                  :key="index"
                  >{{ actionType.title }}</option
                >
              </select> -->
              <div class="btn-group-vertical actions" role="group">
                <button
                  class="btn btn-light btn-sm"
                  :class="{ active: modal.value.actions && modal.value.actions.includes(actionType.id) }"
                  type="button"
                  v-for="(actionType, index) in actionTypes"
                  :key="index"
                  @click="() => toggleAction(actionType.id)"
                >
                  {{ actionType.title }}
                </button>
              </div>
              <div class="form-group">
                <label>Kommentar</label>
                <input class="form-control" v-model="modal.value.comment" />
              </div>
              <button class="btn btn-light form-control" type="button" v-on:click="saveAction">
                Spara
              </button>
              <button class="btn btn-light form-control btn-close" type="button" v-on:click="closeModal">
                Avbryt
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="dialog" v-if="modal.type === 'season'" v-on:click="preventModalClose">
        <div class="dialog-header">
          <h2>Byt säsong</h2>
        </div>
        <div class="dialog-body">
          <form>
            <div class="form-group">
              <label>Planterat:</label>
              <select class="form-control" v-model="modal.value">
                <option :value="season.id" v-for="(season, index) in seasons" :key="index">{{ season.title }}</option>
              </select>
              <button class="btn btn-light form-control" type="button" v-on:click="saveSeason">
                Spara
              </button>
              <button class="btn btn-light form-control btn-close" type="button" v-on:click="closeModal">
                Avbryt
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="dialog" v-if="modal.type === 'confirm'" v-on:click="preventModalClose">
        <div class="dialog-header">
          <h2>Ta bort kommentar</h2>
        </div>
        <div class="dialog-body">
          <div class="row">
            <div class="col-sm-6">
              <button class="btn btn-light form-control" v-on:click="removeNote">
                Ta bort
              </button>
            </div>
            <div class="col-sm-6">
              <button class="btn btn-light form-control" v-on:click="closeModal">
                Avbryt
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog" v-if="modal.type === 'note'" v-on:click="preventModalClose">
        <div class="dialog-header">
          <h2>
            <span>Redigera anteckning</span>
          </h2>
        </div>
        <div class="dialog-body">
          <div class="form-group">
            <label>Anteckning</label>
            <textarea class="form-control" v-model="modal.value.value"></textarea>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <button class="btn btn-light form-control" v-on:click="saveNote">
                Spara
              </button>
            </div>
            <div class="col-sm-6">
              <button class="btn btn-light form-control" v-on:click="closeModal">
                Avbryt
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loader v-if="loading"></loader>
  </div>
</template>

<script>
import { settings } from '@/resources';
import router from '@/router';
import { communicationUtil } from '@/utilities';
import moment from 'moment';

import { Loader } from '@/components';

export default {
  name: 'Spot',
  mixins: [communicationUtil],
  data: function() {
    return {
      loading: false,
      actionTypes: [],
      seasons: [],
      availableSpots: [],
      spot: {},
      modal: {
        visible: false,
        type: '',
        value: undefined
      }
    };
  },
  components: {
    loader: Loader
  },
  mounted: function() {
    this.availableSpots = this.$store.getters.availableSpots;
    this.loadDetails()
      .then(this.loadActionTypes)
      .then(this.loadSeasons)
      .then(() => {
        this.loading = false;
      });
  },
  computed: {
    hasNotes: function() {
      return this.spot && this.spot.notes && this.spot.notes.length > 0;
    },
    isFirstSpot: function() {
      return this.availableSpots.indexOf(this.spot.id) === 0;
    },
    isLastSpot: function() {
      return this.availableSpots.indexOf(this.spot.id) === this.availableSpots.length - 1;
    },
    overdue: function() {
      if (!this.spot.latest_watered) {
        return true;
      }

      return (
        moment().diff(moment(this.spot.latest_watered.time_of_visit), 'days') > this.spot.plant_type.visit_frequency
      );
    },
    season: function() {
      return (
        this.spot.season || {
          id: 1,
          title: 'Ej planterad (tom)'
        }
      );
    },
    map: function() {
      return `${settings.backend}/spot/${this.spot.id}/map`;
    },
    latestActions: function() {
      return [...this.spot.latest_visit.spot_actions.map(a => a.action.title), this.spot.latest_visit.comment]
        .filter(x => x)
        .join(', ');
    }
  },
  methods: {
    formatDate: function(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    loadActionTypes: function() {
      return this.get(`${settings.backend}/actions/types`).then(response => {
        this.actionTypes = response.data;
      });
    },
    loadDetails: function() {
      let spotId = this.$store.getters.selectedSpot;

      this.loading = true;

      return this.get(`${settings.backend}/spot/${spotId}/details`).then(response => {
        this.spot = response.data;
      });
    },
    loadSeasons: function() {
      return this.get(`${settings.backend}/season/list`).then(response => {
        this.seasons = response.data;
      });
    },
    showArea: function() {
      router.push('/area');
    },
    showDescription: function() {
      this.modal.visible = true;
      this.modal.type = 'description';
    },
    showActionDialog: function() {
      this.modal.visible = true;
      this.modal.type = 'action';
      this.modal.value = {
        actions: [],
        comment: ''
      };
    },
    showNoteDialog: function(note) {
      this.modal.type = 'note';
      this.modal.value = {
        id: note ? note.id : 0,
        value: note ? note.value : ''
      };
      this.modal.visible = true;
    },
    showRemoveNoteDialog: function(note) {
      this.modal.type = 'confirm';
      this.modal.value = note;
      this.modal.visible = true;
    },
    showSeasonDialog: function() {
      this.modal.visible = true;
      this.modal.type = 'season';
      this.modal.value = this.spot.season.id;
    },
    showPreviousSpot: function() {
      let newSpotId = this.availableSpots[this.availableSpots.indexOf(this.spot.id) - 1];
      this.$store.commit('spot', newSpotId);
      this.loadDetails().then(response => {
        this.loading = false;
      });
    },
    showNextSpot: function() {
      let newSpotId = this.availableSpots[this.availableSpots.indexOf(this.spot.id) + 1];
      this.$store.commit('spot', newSpotId);
      this.loadDetails().then(response => {
        this.loading = false;
      });
    },
    closeModal: function(e) {
      this.modal.visible = false;
      this.modal.type = '';
    },
    preventModalClose: function(e) {
      e.stopImmediatePropagation();
    },
    saveAction: function() {
      this.loading = true;

      this.post(`${settings.backend}/spot/${this.spot.id}/perform_action`, {
        actions: this.modal.value.actions,
        comment: this.modal.value.comment === '' ? undefined : this.modal.value.comment
      }).then(response => {
        if (response.data.spot_actions.find(({ action }) => action.count_as_visited === 1)) {
          this.spot.latest_visit = response.data;
        }
        if (response.data.spot_actions.find(({ action }) => action.count_as_watered === 1)) {
          this.spot.latest_watered = response.data;
        }
        this.loading = false;
        this.closeModal();
      });
    },
    saveSeason: function() {
      if (this.spot.season.id !== this.modal.value) {
        this.loading = true;

        this.post(`${settings.backend}/spot/${this.spot.id}/change_season`, {
          season: this.modal.value
        }).then(response => {
          this.spot.season = response.data;
          this.loading = false;
          this.closeModal();
        });
        return;
      }

      this.closeModal();
    },
    saveNote: function() {
      this.loading = true;

      this.post(`${settings.backend}/spot/${this.spot.id}/save_note`, {
        id: this.modal.value.id,
        value: this.modal.value.value
      }).then(response => {
        this.spot.notes = response.data;
        this.loading = false;
        this.closeModal();
      });
    },
    removeNote: function() {
      this.loading = true;

      this.post(`${settings.backend}/spot/${this.spot.id}/remove_note`, {
        id: this.modal.value.id
      }).then(response => {
        this.spot.notes = response.data;
        this.loading = false;
        this.closeModal();
      });
    },
    toggleAction: function(id) {
      if (this.modal.value.actions.includes(id)) {
        this.modal.value.actions = this.modal.value.actions.filter(v => v !== id);
        return;
      }

      this.modal.value.actions.push(id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Spot.vue